import styled from 'styled-components';

import { fonts, MultilineTextOverflow } from '@dreryk/react-components';

export const StyledFormsTemplatesListItemActiveNameMultilineTextOverflow = styled(MultilineTextOverflow)`
   font-weight: ${fonts.fontWeightBold};
`;
